import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { LegalPage } from "@/components/pages/LegalPage";
import { fr } from "@/i18n/fr";

export const Route = createFileRoute("/mentions-legales")({
  head: () =>
    buildHead({
      lang: "fr",
      page: "home",
      title: fr.legal.page.title + " · 2AM Hospitality",
      description: fr.legal.page.intro,
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "fr") i18n.changeLanguage("fr");
    }, []);
    if (i18n.language !== "fr") i18n.changeLanguage("fr");
    return <LegalPage />;
  },
});
